import {
    ColumnDefinition,
    ColumnDefinitionsDictionary,
    getColDefsForColumnDefinitionsDictionary,
    LONG_DATE_PRECISION,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';
import { IndigoAppContextType } from 'app/AppContext.tsx';

export type HistoricalPercentageChangeWidgetGridColumn =
    | 'date'
    | 'close'
    | 'percentChange'
    | 'volume';

export const historicalPercentageChangeWidgetGridColumnsDefinitionDictionary: ColumnDefinitionsDictionary<HistoricalPercentageChangeWidgetGridColumn> =
    {
        date: {
            field: 'date',
            name: 'Date',
            valueType: ValueType.DATE,
            precision: LONG_DATE_PRECISION,
            headerTooltip: 'Date',
        },
        close: {
            field: 'price',
            name: 'Price',
            valueType: ValueType.NUMBER,
            raw: true,
            isPercentage: false,
            headerTooltip: 'PNC or todays last price',
        },
        percentChange: {
            field: 'percentChange',
            name: '% Change',
            valueType: ValueType.NUMBER,
            precision: 2,
            isPercentage: true,
            headerTooltip: 'Price % Change',
        },
        volume: {
            field: 'volume',
            name: 'Volume',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'Volume',
        },
    };

export const historicalPercentageChangeWidgetColumnsDefinitions: ColumnDefinition[] =
    Object.values(
        historicalPercentageChangeWidgetGridColumnsDefinitionDictionary
    );

export function getHistoricalPercentageChangeWidgetColDefs(
    context: IndigoAppContextType
) {
    return getColDefsForColumnDefinitionsDictionary(
        context,
        historicalPercentageChangeWidgetGridColumnsDefinitionDictionary
    );
}
